import React from "react";
import { getDate } from "utils/formatDate";

const Footer = (props) => {
  let { thongTin } = props;
  let { ExpiredDate } = thongTin ? thongTin : {};
  return (
    <footer className="footer footer-static footer-light navbar-border">
      <p className="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
        <span className="float-md-left d-block d-md-inline-block">
          Copyright &copy; 2011-2021{" "}
          <a
            className="text-bold-800 grey darken-2"
            href={() => false}
            target="_blank"
          >
            Niềm Tin{" "}
          </a>
          , All rights reserved. <code>Phiên bản 8.1</code>
        </span>
        {/* <span className="text-time">
          Thời hạn sử dụng: {getDate(ExpiredDate)}
        </span> */}
        <span className="float-md-right d-block d-md-inline-blockd-none d-lg-block text-footer arrow-ribbon footer-color">
          Phần mềm quản lý Cầm đồ số 1 Việt Nam
        </span>
      </p>
    </footer>
  );
};

export default Footer;
